import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { ProjectPanelLayout } from './ProjectPanelLayout';

interface ProjectSectionHubProps {
  title: string;
  titleIcon: LucideIcon;
  intro: string;
  loading?: boolean;
  children: React.ReactNode;
}

export const ProjectSectionHub: React.FC<ProjectSectionHubProps> = ({
  title,
  titleIcon,
  intro,
  loading = false,
  children,
}) => {
  return (
    <ProjectPanelLayout title={title} titleIcon={titleIcon} loading={loading}>
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-6">
        <p className="max-w-2xl text-sm text-muted-foreground">{intro}</p>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">{children}</div>
      </div>
    </ProjectPanelLayout>
  );
};
